exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,198,181,.5);z-index:1000}.loader__inner{position:relative;width:100%;height:100%}.loader__inner .spinner{right:50%;transform:translate(-50%,-50%);width:80px;height:80px}.loader__inner .spinner:after{border-width:8px;width:80px;height:80px}", ""]);

// exports
